<template>
  <div class="row">
    <!-- Statistiques de l'agent -->
    <div class="col-lg-3 col-sm-6 mb-25">
      <div class="card border-0 rounded-0 bg-white">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
          <div class="d-flex align-items-center justify-content-between">
            <div class="flex-shrink-0">
              <i class="flaticon-folder text-primary" style="font-size: 40px;"></i>
            </div>
            <div class="flex-grow-1 ms-3">
              <span class="count fw-bold text-black d-block mb-0" style="font-size: 30px;">
                {{ stats.totalFiles }}
              </span>
              <p class="text-body-tertiary fs-12 fw-medium mb-0">Files assignées</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-3 col-sm-6 mb-25">
      <div class="card border-0 rounded-0 bg-white">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
          <div class="d-flex align-items-center justify-content-between">
            <div class="flex-shrink-0">
              <i class="flaticon-file text-warning" style="font-size: 40px;"></i>
            </div>
            <div class="flex-grow-1 ms-3">
              <span class="count fw-bold text-black d-block mb-0" style="font-size: 30px;">
                {{ stats.pendingTasks }}
              </span>
              <p class="text-body-tertiary fs-12 fw-medium mb-0">Dossiers en attente</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-3 col-sm-6 mb-25">
      <div class="card border-0 rounded-0 bg-white">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
          <div class="d-flex align-items-center justify-content-between">
            <div class="flex-shrink-0">
              <i class="flaticon-check text-success" style="font-size: 40px;"></i>
            </div>
            <div class="flex-grow-1 ms-3">
              <span class="count fw-bold text-black d-block mb-0" style="font-size: 30px;">
                {{ stats.completedTasks }}
              </span>
              <p class="text-body-tertiary fs-12 fw-medium mb-0">Dossiers traités</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-3 col-sm-6 mb-25">
      <div class="card border-0 rounded-0 bg-white">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
          <div class="d-flex align-items-center justify-content-between">
            <div class="flex-shrink-0">
              <i class="flaticon-time text-info" style="font-size: 40px;"></i>
            </div>
            <div class="flex-grow-1 ms-3">
              <span class="count fw-bold text-black d-block mb-0" style="font-size: 30px;">
                {{ stats.inProgressTasks }}
              </span>
              <p class="text-body-tertiary fs-12 fw-medium mb-0">En cours</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Files assignées -->
    <div class="col-12 mb-25">
      <div class="card border-0 rounded-0 bg-white">
        <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
          <h4 class="fw-bold text-black mb-0">Mes Files de Validation</h4>
          <button @click="loadAgentData" class="btn btn-primary btn-sm">
            <i class="flaticon-refresh me-1"></i> Actualiser
          </button>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25">
          <div v-if="loading" class="text-center py-4">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Chargement...</span>
            </div>
          </div>
          
          <div v-else-if="assignedQueues.length === 0" class="text-center py-4">
            <i class="flaticon-folder-open text-muted" style="font-size: 48px;"></i>
            <p class="text-muted mt-2">Aucune file assignée pour le moment</p>
          </div>

          <div v-else class="row">
            <div v-for="queue in assignedQueues" :key="queue.id" class="col-md-6 col-lg-4 mb-3">
              <div class="queue-card" :class="getRiskCardClass(queue.maxRiskLevel)">
                <div class="queue-card-header">
                  <h6 class="fw-bold mb-1">{{ queue.name }}</h6>
                  <p class="small text-muted mb-2">{{ queue.code }}</p>
                  <div class="d-flex justify-content-between align-items-center">
                    <span class="badge" :class="getRiskBadgeClass(queue.maxRiskLevel)">
                      {{ getRiskLabel(queue.maxRiskLevel) }}
                    </span>
                    <span class="badge bg-primary">
                      {{ getBescsCount(queue.id) }} dossiers
                    </span>
                  </div>
                </div>
                <div class="queue-card-body">
                  <router-link 
                    :to="{ name: 'AgentFilesPage', query: { queueId: queue.id } }"
                    class="btn btn-primary btn-sm w-100"
                  >
                    <i class="flaticon-folder-open me-1"></i> Voir les dossiers
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tâches récentes -->
    <div class="col-12">
      <div class="card border-0 rounded-0 bg-white">
        <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
          <h4 class="fw-bold text-black mb-0">Tâches Récentes</h4>
          <router-link to="/agent-files" class="btn btn-outline-primary btn-sm">
            Voir toutes les tâches
          </router-link>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25">
          <div class="table-responsive">
            <table class="table align-middle mb-0">
              <thead>
                <tr>
                  <th>Référence BESC</th>
                  <th>File</th>
                  <th>Statut</th>
                  <th>Priorité</th>
                  <th>Date limite</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="task in recentTasks" :key="task.id">
                  <td class="fw-medium">{{ task.validationTask.besc?.refbesc }}</td>
                  <td>{{ task.validationTask.validationqueue?.name }}</td>
                  <td>
                    <span v-html="getStatusBadge(task.result)"></span>
                  </td>
                  <td>
                    <span v-html="getPriorityBadge(task.validationTask.priority)"></span>
                  </td>
                  <td>{{ format_date(task.validationTask.sla_due_at) }}</td>
                  <td>
                    <router-link 
                      v-if="task.validationTask.besc?.id"
                      :to="{ name: 'ViewBesc', params: { id: task.validationTask.besc.id } }"
                      class="btn btn-primary btn-sm"
                      title="Voir le dossier"
                    >
                      <i class="flaticon-eye"></i>
                    </router-link>
                    <span v-else class="btn btn-secondary btn-sm disabled">
                      <i class="flaticon-eye"></i>
                    </span>
                  </td>

                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import ApiService from '@/services/ApiService';
import JwtService from '@/services/JwtService';
import { error, format_date } from '@/utils/utils';
import { BescInQueue } from '@/models/BescInQueue';
import { ValidationQueues } from '@/models/ValidationTask';

interface AgentStats {
  totalFiles: number;
  pendingTasks: number;
  completedTasks: number;
  inProgressTasks: number;
}

interface ValidationQueue {
  id: string;
  name: string;
  code: string;
  description: string;
  minRiskLevel: string;
  maxRiskLevel: string;
  pays: any;
  port: any;
}

interface ValidationTaskInfo {
  id: string;
  priority: string;
  validationqueue: {
    id: string;
    name: string;
  };
  besc: {
    id: string;
    refbesc: string;
  };
  sla_due_at: string;
}

interface RecentTask {
  id: string;
  result: string; 
  validationTask: ValidationTaskInfo;
  tache: {
    id: string;
    title: string;
    check_code: string;
  };
}

export default defineComponent({
  name: 'AgentDashboard',
  setup() {
    const loading = ref(false);
    const stats = ref<AgentStats>({
      totalFiles: 0,
      pendingTasks: 0,
      completedTasks: 0,
      inProgressTasks: 0
    });

    const assignedQueues = ref<ValidationQueue[]>([]);
    const recentTasks = ref<RecentTask[]>([]);
    const queues = ref<ValidationQueues[]>([]);
    const bescs = ref<BescInQueue[]>([]);

    async function loadQueues() {
      try {
        const { data } = await ApiService.get("/validation-queues");
        queues.value = data.data || [];
        await loadBescsInQueues();
      } catch (err: any) {
        error(err.response?.data?.message || "Erreur de chargement des files");
      }
    }

    const loadAgentData = async () => {
      loading.value = true;
      try {
        const user = JwtService.getUser();
        if (!user) {
          error("Utilisateur non connecté");
          return;
        }

        const statsResponse = await ApiService.get(`/agent/stats/${user.userId}`);
        stats.value = statsResponse.data.data;

        const queuesResponse = await ApiService.get(`/agent/queues/${user.userId}`);
        assignedQueues.value = queuesResponse.data.data;

        const tasksResponse = await ApiService.get(`/agent/recent-tasks/${user.userId}?limit=5`);
        console.log("vallllllll",tasksResponse);
        recentTasks.value = tasksResponse.data.data.map((check: any) => ({
          ...check
        }));

      } catch (err: any) {
        error(err.response?.data?.message || 'Erreur lors du chargement des données');
      } finally {
        loading.value = false;
      }
    };

    // Fonctions de style pour les risques
    const getRiskCardClass = (riskLevel: string): string => {
      const classes: Record<string, string> = {
        'HIGH': 'risk-high',
        'MEDIUM': 'risk-medium', 
        'LOW': 'risk-low'
      };
      return classes[riskLevel] || 'risk-low';
    };

    const getRiskBadgeClass = (riskLevel: string): string => {
      const classes: Record<string, string> = {
        'HIGH': 'bg-danger',
        'MEDIUM': 'bg-warning',
        'LOW': 'bg-success'
      };
      return classes[riskLevel] || 'bg-secondary';
    };

    const getRiskLabel = (riskLevel: string): string => {
      const labels: Record<string, string> = {
        'HIGH': 'Élevé',
        'MEDIUM': 'Moyen',
        'LOW': 'Faible'
      };
      return labels[riskLevel] || riskLevel;
    };

    // Nombre de tâches dans une file
    const getQueueTasksCount = (queueId: string): number => {
      return recentTasks.value.filter(task => task.validationTask.validationqueue?.id === queueId).length;
    };

    // Chargement des BESCs par file
    async function loadBescsInQueues() {
      try {
        const { data } = await ApiService.get("/bescs/in-queues");
        bescs.value = data.data || [];
      } catch (err: any) {
        console.error("Erreur chargement BESCs:", err);
      }
    }

    const getBescsByQueue = (queueId: string): BescInQueue[] => {
      return bescs.value.filter(b => b.queueId === queueId);
    };

    const getBescsCount = (queueId: string): number => {
      return getBescsByQueue(queueId).length;
    };

    // Badges statut
    const getStatusBadge = (status: string): string => {
      const badges: Record<string, string> = {
        'PENDING': '<span class="badge bg-primary">En attente</span>',
        'IN_PROGRESS': '<span class="badge bg-info">En cours</span>',
        'COMPLETED': '<span class="badge bg-success">Terminée</span>',
        'RETURNED_FOR_CORRECTION': '<span class="badge bg-warning">Retour correction</span>',
        'CANCELLED': '<span class="badge bg-danger">Annulée</span>'
      };
      return badges[status] || `<span class="badge bg-secondary">${status}</span>`;
    };

    // Badges priorité
    const getPriorityBadge = (priority: string): string => {
      const badges: Record<string, string> = {
        'LOW': '<span class="badge bg-success">Faible</span>',
        'NORMAL': '<span class="badge bg-info">Normale</span>',
        'HIGH': '<span class="badge bg-warning">Élevée</span>',
        'CRITICAL': '<span class="badge bg-danger">Critique</span>'
      };
      return badges[priority] || `<span class="badge bg-secondary">${priority}</span>`;
    };

    

    onMounted(() => {
      loadAgentData();
      loadQueues();
    });

    return {
      loading,
      stats,
      assignedQueues,
      recentTasks,
      loadAgentData,
      getRiskCardClass,
      getRiskBadgeClass,
      getRiskLabel,
      getQueueTasksCount,
      getStatusBadge,
      getPriorityBadge,
      format_date,
      getBescsByQueue,
      getBescsCount
    };
  }
});
</script>

<style scoped>
.queue-card {
  border: 1px solid #e9ecef;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.queue-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.queue-card-header {
  padding: 1rem;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.queue-card-body {
  padding: 1rem;
}
</style>